import React from 'react';
import { IconButton } from '@mui/material';
import { withStyles } from '@mui/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';

const actionsStyles = theme => ({
  root: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    marginRight: theme.spacing(2.5),
  },
});
function TablePaginationActions({ classes, count, page, rowsPerPage, theme, onPageChange, goBack = null, }) {
  return (
    <div className={classes.root}>
      <IconButton
        onClick={e => onPageChange(e, Math.max(0, Math.ceil(count / rowsPerPage) - 1))}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="Last Page"
        size="large">
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
      <IconButton
        onClick={e => onPageChange(e, page + 1)}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="Next Page"
        size="large">
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={e => onPageChange(e, page - 1)}
        disabled={page === 0}
        aria-label="Previous Page"
        size="large">
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={e => onPageChange(e, 0)}
        disabled={page === 0}
        aria-label="First Page"
        size="large">
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      {goBack}
    </div>
  );
}

export default withStyles(actionsStyles, { withTheme: true })(TablePaginationActions);